import React from "react";

function StaffDashboard() {
  return (
    <div style={{ maxWidth: "900px", margin: "50px auto", textAlign: "center" }}>
      <h1>Staff Tools</h1>
      <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginTop: "40px" }}>
        <div
          style={{ padding: "50px", background: "#4A90E2", color: "white", borderRadius: "15px", cursor: "pointer" }}
          onClick={() => window.open("https://cpanel-pr.bdsmw.com:2096/cpsess6318972963/webmail/paper_lantern/index.html?login=1&post_login=14913812195310", "_blank")}
        >
          <h2>Staff Webmail</h2>
        </div>
        <div
          style={{ padding: "50px", background: "#F5A623", color: "white", borderRadius: "15px", cursor: "pointer" }}
          onClick={() => window.open("http://192.168.0.5:8004/home_page/10/edit", "_blank")}
        >
          <h2>MBS Dashboard</h2>
        </div>
      </div>
    </div>
  );
}

export default StaffDashboard;
